import initialState from "./initialState.prod";
export default initialState;